import { render } from "./List.vue?vue&type=template&id=717a4474&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=717a4474&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-717a4474"

export default script